const API_PROTOCOL = "https://";
const API_VERSION = "/api/v1";
// const API_ENV = window.location.host.includes("pre") ? "t" : "i";
const API_ENV = window.location.host.includes("pre") ? "t" : ( window.location.host.includes("int") || window.location.host.includes("local") ) ? "i" : "p";
// const API_ENV = window.location.host.includes("pre") ? "p" : ( window.location.host.includes("int") || window.location.host.includes("local") ) ? "i" : "p";

const APIS: any = {
    identity: API_PROTOCOL + "eapi-raas-identity-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    profmanag: API_PROTOCOL + "eapi-raas-profmanag-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    bking: API_PROTOCOL + "eapi-raas-bking-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    plan: API_PROTOCOL + "eapi-raas-plan-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    financial: API_PROTOCOL + "eapi-raas-financial-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    support: API_PROTOCOL + "eapi-raas-support-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    commercial: API_PROTOCOL + "eapi-raas-commercial-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    customers:API_PROTOCOL + "eapi-raas-customers-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION,
    trvlmanag:API_PROTOCOL + "eapi-raas-trvlmanag-v1-" + API_ENV + ".de-c1.cloudhub.io" + API_VERSION
    //trvlmanag:API_PROTOCOL + "eapi-raas-trvlmanag-v1-" + "i" + ".de-c1.cloudhub.io" + API_VERSION
}

/**
 * 
 * @param apiName 
 * @param url 
 * @returns {string} URL of endpoint to consume
 */
export function getEndpoint(apiName: string, url: string): string {
    if (process.env.NODE_ENV === environments.DEV) {
        const queryType = url.includes("?") ? "&" : "?";
        return "http://localhost:3003" + url + queryType+"api=" + apiName;
    } else {
        let urlOutput = APIS[apiName] + url;
        return urlOutput;
    }
}

export enum environments {
    DEV = "development",
    PRO = "production"
}

export enum apiNames {
    IDENTITY = "identity",
    PROFMANAG = "profmanag",
    BKING = "bking",
    PLAN = "plan",
    FINANCIAL = "financial",
    SUPPORT = "support",
    COMMERCIAL = "commercial",
    CUSTOMERS="customers",
    TRVLMANAG="trvlmanag"
}